const actions = {
  setInners({ commit }, list) {
    commit('SET_INNERS', list);
  },
  setCheckboxStaff({ commit }, list) {
    commit('SET_CHECKBOX_STAFF', list);
  },
  setStaffIds({ commit }, list) {
    commit('SET_STAFF_IDS', list);
  },
  setHostId({ commit }, list) {
    commit('SET_HOST_ID', list);
  },
  setStaffParentId({ commit }, id) {
    commit('SET_PARENT_ID', id);
  },
  setHostParentId({ commit }, id) {
    commit('SET_HOST_PARENT_ID', id);
  },
  setSelectStaffParentId({ commit }, id) {
    commit('SET_SELECT_STAFF_PARENT_ID', id);
  },
  setOrganizer({ commit }, data) {
    commit('SET_ORGANIZER', data);
  },
  setOuters({ commit }, list) {
    commit('SET_OUTERS', list);
  },
  setRequires({ commit }, list, info) {
    commit('SET_REQUIRES', list, info);
  },
  setRequiresInfo({ commit }, info) {
    commit('SET_REQUIRES_INFO', info);
  },
  setOutersIds({ commit }, list) {
    commit('SET_OUTERS_IDS', list);
  },
  setSubmitForm({ commit }, data) {
    commit('SET_FORM', data);
  },
  setVoucherApplicationForm({ commit }, data) {
    commit('SET_VOUCHER_APPLICATION_FORM', data);
  },
  setMealBookForm({ commit }, data) {
    commit('SET_MEAL_BOOK_FORM', data);
  },
  setBookingLimitTime({ commit }, data) {
    commit('SET_BOOKING_LIMIT_TIME', data);
  },
  setRoomData({ commit }, data) {
    commit('SET_ROOM_DATA', data);
  },
  setFloorInfo({ commit }, data) {
    commit('SET_FLOOR_INFO', data);
  },
  setInviteData({ commit }, data) {
    commit('SET_INVITE_DATA', data);
  },
  clearSubmitForm({ commit }) {
    commit('CLEAR_FORM');
  },
  clearVoucherApplicationForm({ commit }) {
    commit('CLEAR_VOUCHER_APPLICATION_FORM');
  },
  clearMealBookForm({ commit }) {
    commit('CLEAR_MEAL_BOOK_FORM');
  },
  setDate({ commit }, data) {
    commit('SET_DATE', data);
  },
  setSelectStaffId({ commit }, data) {
    commit('SET_SELECT_STAFF_ID', data);
  },
  setCouponInfo({ commit }, data) {
    commit('SET_COUPON_INFO', data);
  },
  setIncludeName({ commit }, data) {
    commit('SET_INCLUDE_NAME', data);
  },
  clearIncludeName({ commit }, data) {
    commit('CLEAR_INCLUDE_NAME', data);
  }
};

export default actions;
